import { Switch, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import InvitesApp from './eero/InvitesApp';
import TMobileInvitesApp from './tmobile/TMobileInvitesApp';
import TMobileMyNewEeroApp from './tmobile/TMobileMyNewEeroApp';
import TMobileAppApp from './tmobile/TMobileAppApp';
import TMobileAddOrReplaceDeviceApp from './tmobile/TMobileAddOrReplaceDeviceApp';
import TMobileKilimanjaroApp from './tmobile/TMobileKilimanjaroApp';
import MyNewEeroApp from './eero/MyNewEeroApp';
import AppApp from './eero/AppApp';
import AddOrReplaceDeviceApp from './eero/AddOrReplaceDeviceApp';
import KilimanjaroApp from './eero/KilimanjaroApp';
import PlusPurchaseCompleteApp from './eero/PlusPurchaseCompleteApp';
import SubscriptionReferralApp from './eero/SubscriptionReferralApp';

function RedirectToEero() {
    window.location.href = "https://eero.com";
  
    return <div>Redirecting...</div>;
}  

function RedirectToEeroPlus() {
    window.location.href = "https://eero.com/plus";

    return <div>Redirecting...</div>;
}

function ApplinksApp() {
    const location = useLocation();
    const [cssTheme, setCssTheme] = useState('');
    
    useEffect(() => {
        // Set theme class based on route
        if (location.pathname.startsWith('/tmobile')) {
            setCssTheme('tmobile-theme');
            document.body.className = 'tmobile-theme';
        } else {
            setCssTheme('');
            document.body.className = '';
        }
    }, [location.pathname]);
    
    return (
       <div className={cssTheme}>
         <Switch>
        <Route path="/invites">
          <InvitesApp />
        </Route>
        <Route path="/my-new-eero">
          <MyNewEeroApp />
        </Route>
        <Route path="/app">
          <AppApp />
        </Route>
        <Route path="/addorreplacedevice">
          <AddOrReplaceDeviceApp />
        </Route>        
        <Route path="/kmj">
          <KilimanjaroApp />
        </Route>
        <Route path="/pluspurchasecomplete">
          <PlusPurchaseCompleteApp />
        </Route>
        <Route path="/subscriptionreferral">
          <SubscriptionReferralApp />
        </Route>
        <Route path="/premiumpurchase">
          <RedirectToEeroPlus />
        </Route>
        <Route path="/tmobile/invites">
          <TMobileInvitesApp />
        </Route>
        <Route path="/tmobile/my-new-eero">
          <TMobileMyNewEeroApp />
        </Route>
        <Route path="/tmobile/app">
          <TMobileAppApp />
        </Route>
        <Route path="/tmobile/addorreplacedevice">
          <TMobileAddOrReplaceDeviceApp />
        </Route>
        <Route path="/tmobile/kmj">
          <TMobileKilimanjaroApp />
        </Route>
        <Route path="*">
          <RedirectToEero />
        </Route>        
         </Switch>
       </div>
    );
}

export default ApplinksApp
